import React from "react";
import { Modal, Box } from "@mui/material";
import TableComponent from "@components/TableComponent/TableComponent";
import ButtonComponent from "@components/ButtonComponent";

const columns = [
  { key: 'type', label: 'Error Type', thClass: 'px-2 py-2 font-semibold', tdClass: 'px-2 py-2' },
  { key: 'message', label: 'Message', thClass: 'px-2 py-2 font-semibold', tdClass: 'px-2 py-2' },
  { key: 'details', label: 'Details', thClass: 'px-2 py-2 font-semibold', tdClass: 'px-2 py-2' },
];

const SheetErrorModal = ({ open, onClose, error = { type: "", message: "", details: "" } }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="sheet-error-modal-title"
      aria-describedby="sheet-error-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 1000,
          bgcolor: "background.paper",
          borderRadius: 3,
          boxShadow: 24,
          p: 0,
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          border: "1px solid #E5E7EB",
        }}
      >
        {/* Ghost close button at top right */}
        <ButtonComponent
          onClick={onClose}
          className="absolute text-gray-400 transition-colors right-5 top-5 hover:text-gray-600"
          variant="ghost"
          aria-label="Close"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </ButtonComponent>
        <h2
          id="sheet-error-modal-title"
          className="font-inter font-medium not-italic text-[20px] leading-[1.2] tracking-[-0.01em] mb-3 text-left w-full"
        >
          Error Details
        </h2>
        <div className="w-full overflow-hidden rounded-[10px] mb-4">
          <TableComponent
            columns={columns.map(col => ({ ...col }))}
            data={[error]}
            styleProps={{
              container: 'w-full font-inter font-normal not-italic text-[15px] leading-[1.4] text-gray-700 text-left rounded-[10px]',
              table: 'w-full border-collapse rounded-t-[10px]',
              thead: 'rounded-t-[10px] overflow-hidden',
              scroll: 'overflow-y-auto',
            }}
          />
        </div>
        <div
          className="font-inter font-normal not-italic text-[14px] leading-[1.4] text-gray-700 text-left w-full mb-6"
        >
          Please fix above errors and try again
        </div>
        <div className="flex justify-end w-full">
          <ButtonComponent
            variant="secondary"
            onClick={onClose}
          >
            Close
          </ButtonComponent>
        </div>
      </Box>
    </Modal>
  );
};

export default SheetErrorModal;